import React from 'react';
import getName from '../../utils/getName';
import useMedicalProfileOwner from '../../hooks/api/useMedicalProfileOwner';
import urls from '../../utils/urls';
import { getIntl } from '../../utils/intl';
import Stack from './Stack';
import { LoadableAvatar } from './Avatar';
import { getSpacing } from '../../utils/spacing';
import Text from './Text';

const intl = getIntl('profile-owner', {
    owner: 'Profile Organizer',
});

type ProfileOwnerAvatarProps = {
    medicalProfileId: string;
    includeTransferRequestNavigation?: boolean;
};

const ProfileOwnerAvatar: React.FC<ProfileOwnerAvatarProps> = ({ medicalProfileId }) => {
    const { owner, isLoading } = useMedicalProfileOwner({ medicalProfileId });

    if (isLoading || !owner) return null;

    return (
        <Stack horizontal fullWidth align="center" space={getSpacing(2.5)}>
            <LoadableAvatar
                size="md"
                avatarUrl={urls.api.medicalProfiles.owner.avatar(medicalProfileId)}
                firstName={owner.firstName}
                lastName={owner.lastName}
            />
            <Stack vertical space={getSpacing(1)} justify="center">
                <Text variant="h6">{getName(owner)}</Text>
                <Text variant="caption-1">{intl('owner')}</Text>
            </Stack>
        </Stack>
    );
};

export default React.memo(ProfileOwnerAvatar);
